<form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
   <h3 class="login-head"><i class="fa fa-lg fa-fw fa-user"></i> APPLICANT LOGIN </h3>

   <div class="form-group">
     <label class="control-label">REFERENCE #</label>
     <input type="text" required=""
           [ngClass]="{ 'is-invalid': submitted && loginFormControls.id.errors }"
                               formControlName="id"
            class="form-control" placeholder="Enter Reference #" autofocus>

   </div>
   <div class="form-group">
     <label class="control-label">PIN</label>
     <input type="password"  class="form-control" placeholder="Enter Pin" required=""
        [ngClass]="{ 'is-invalid': submitted && loginFormControls.password.errors }"
        formControlName="password">
   </div>
   <div class="form-group">
     <div class="utility">
       <div class="animated-checkbox">
         <label>
           <input type="checkbox"><span class="label-text">Stay Signed in</span>
         </label>
       </div>
       <!-- <a class="semibold-text mb-2"><a [routerLink]="[ '/account/forget-password' ]" data-toggle="flip">Lost Pin ?</a></p> -->
     </div>
   </div>
   <div class="form-group btn-container">
    <label class="text-danger" *ngIf="message">{{message}} Admission is Over</label>

      <button class="btn btn-primary btn-block"
      [disabled]="!loginForm.valid">
      <i [ngClass]="{'fa fa-refresh fa-spin': showLoadingIndicator}"></i>
      LOGIN</button>

   </div>

 </form>

